function savedDesignsInit() {
	const handleDeeplinkingToDesign = () => {
		var urlParams = new URLSearchParams(window.location.search);
		var designId = urlParams.get('design') ?? null;
		if (!urlParams.has('variant') && designId) {
			let checkExist = setInterval(function() {
				const designEl = document.querySelector(`.option-item[data-design-id="${designId}"] label`);
				const designsTab = document.querySelector('.pdp-tab.saved-designs');
				if (designEl && designsTab) {
					clearInterval(checkExist);
					designsTab.click();
					setTimeout(() => {
						$(`.option-item:not([data-design-id="${designId}"]) input:checked`).removeAttr('checked');
						designEl.click();
					}, 200);
				}
			}, 500);
		}
		else if (urlParams.has('variant')) {
			$('.color-options-more').click();
		}
	}
	const clearSavedDesign = (designId) => {
		const designsByProductId = Object.entries(localStorage)
			.filter(([key]) => key.startsWith("customDesign--"))
			.forEach(([key, value]) => {
				const designs = JSON.parse(value);
				const oldCount = designs.design_product.length;
				designs.design_product = designs.design_product.filter(design => design.designProduct.design.id != designId);

				if (oldCount !== designs.design_product.length) {
					localStorage.setItem(key, JSON.stringify(designs));
				}
			});
	};

	const checkItemsCount = () => {
		if ($(".saved-designs-drawer__item").length) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--empty");
		} else {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active").addClass("saved-designs-drawer--empty");
		}
	}

	const renderItems = () => {
		const savedDesigns = window.getSavedDesigns();

		$(".saved-designs-drawer__item").remove();
		
		$.each(savedDesigns, function () {

			$(".saved-designs-drawer__panel").append(
				"<div class='saved-designs-drawer__item' data-saved-product-design-id='" + this.id + "'>" +
				"<a class='saved-designs-drawer__item-media' href='" + this.url + "' aria-label='View " + this.title + "'>" +
				"<img class='saved-designs-drawer__item-image' src='" + this.image + "' alt='" + this.title + "'/>" +
				"</a>" +
				"<div class='saved-designs-drawer__item-detail'>" +
				"<a class='saved-designs-drawer__item-title' href='#' aria-label='View " + this.title + "'>" + this.title + "</a>" +
				"<div class='saved-designs-drawer__item-price'>Designed at " + this.price + "</div>" +
				"<a class='saved-designs-drawer__item-btn' href='" + this.url + "' aria-label='View Design'>View Design</a>" +
				"<a class='saved-designs-drawer__item-btn saved-designs-drawer__item-btn--alt' onclick='GorgiasChat.open();' aria-label='View Expert&lsquo;s Advice'>Expert&lsquo;s Advice</a>" +
				"</div>" +
				"<button class='saved-designs-drawer__item-remove' aria-label='Remove Item'></button>" +
				"</div>"
			);
		});

		$(".saved-designs-drawer__item-remove").on("click", function () {
			const item = $(this).parents(".saved-designs-drawer__item"),
				itemId = item.attr('data-saved-product-design-id');

			item.fadeOut(200, function () {
				$(this).remove();
				checkItemsCount();
			});
			clearSavedDesign(itemId);
		});

		checkItemsCount();
	}

	$(".saved-designs-drawer__tab").on("click", function () {
		if ($(".saved-designs-drawer").hasClass("saved-designs-drawer--active")) {
			$(".saved-designs-drawer").removeClass("saved-designs-drawer--active");
			$("body").removeClass("saved-designs-drawer--active");
		} else {
			$(".saved-designs-drawer").addClass("saved-designs-drawer--active");
			$("body").addClass("saved-designs-drawer--active");
		}
	});

	renderItems();
	setTimeout(() => handleDeeplinkingToDesign(), 1500);
	window.addEventListener('customDesignSaved', (e) => renderItems());
}
savedDesignsInit();